import { FC } from 'react';
import type { BasicDetailsComponentPropsTypes } from './types/propsTypes';
import { DetailsType } from './types/enums';
import styles from './BasicDetailsComponent.module.scss';

const BasicDetailsComponent: FC<BasicDetailsComponentPropsTypes> = ({
  brandName,
  productName,
  detailsType,
  isSingleLineBasicDetail = false,
}: BasicDetailsComponentPropsTypes): JSX.Element => {
  const basicDetailsClassName = () => {
    switch (detailsType) {
      case DetailsType.PLPHEADERCARD:
        return 'basic-details-plp-header-container';
      case DetailsType.AllPRODUCTCARD:
        return 'basic-details-product-card-container';
      case DetailsType.DETAILSSEARCHRESULTCARD:
        return 'basic-details-search-result-card-container';
      case DetailsType.DETAILSABOCHECKBOXCARD:
        return 'basic-details-abo-checkbox-card-container';
      case DetailsType.PDP_DETAILS:
        return 'basic-details-pdp-container';
      case DetailsType.PLP_SEARCH_CARD:
        return 'basic-details-plp-search-card';
      case DetailsType.VARIANT_DRAWER_CARD:
        return 'basic-details-variant-drawer-card';
      case DetailsType.PDP_HEADER_CARD:
        return 'basic-details-pdp-header-card';
      case DetailsType.CART_CARD_VARIANT:
        return 'basic-details-variant-cart-card';
      case DetailsType.CART_CARD_MOBILE_VARIANT:
        return 'basic-details-variant-cart-card-mobile-view-force';
      case DetailsType.FREE_PRODUCT_CARD:
        return 'basic-details-free-product-card';
      case DetailsType.CHECKOUT_CARD:
        return 'basic-details-checkout-card';
      case DetailsType.APOINT_REDEEM_PRODUCT_CARD:
        return 'basic-details-apoint-redeem-product-card';
      case DetailsType.APOINT_REDEEM_PRODUCT_CARD_PRICE_DETAILS:
        return 'basic-details-apoint-redeem-product-card-price-details';
      case DetailsType.APOINT_REDEEM_CARD_PRICE_DETAILS:
        return 'basic-details-apoint-redeem-card-price-details';
      case DetailsType.HORIZONTAL_CARD_DETAILS:
        return 'horizontal-card-details';
      default:
        return 'basic-details-container';
    }
  };

  return (
    <div className={`${styles[basicDetailsClassName()]}`} data-testid="basic-detail-component-test-id">
      {isSingleLineBasicDetail ? (
        <h2 className={styles['combined-brand-product-name']}>{`${brandName} ${productName}`}</h2>
      ) : (
        <>
          {brandName && (
            <h2 className={styles['brand-name']} data-testid="brand-name-test">
              {brandName}
            </h2>
          )}
          {productName && (
            <h4 className={styles['product-name']} data-testid="product-name-test">
              {productName}
            </h4>
          )}
        </>
      )}
    </div>
  );
};

export default BasicDetailsComponent;
export type { BasicDetailsComponentPropsTypes };
export { DetailsType };
